<app-student-module ModuleName="Student Achievements" [Loading]="loading" [PrintOptions]="printOptions"
                    [NewHidden]="false" (New)="openAdd(content)">
  <sortable-table [data]="achievements" [headers]="headers"
                  [showDelete]="true" (delCall)="remove($event)"
                  [showEdit]="true" (editCall)="edit($event, content)"
                  defaultSort="date"></sortable-table>
</app-student-module>

<ng-template #content let-modal>
  <form #addAchievementForm="ngForm" (submit)="save(achievement, addAchievementForm)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" *ngIf="!achievement.id">Add Achievement</h4>
      <h4 class="modal-title" id="modal-basic-title" *ngIf="achievement.id">Edit Achievement</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="date" class="required-field">Date</label>
        <input type="date" class="form-control" id="date" name="date" [(ngModel)]="achievement.date" required
               #date="ngModel" [max]="maxDate">
        <ng-container *ngIf="date.touched && date.errors">
          <span *ngIf="date.errors['required']" class="text-danger">You must provide a date for the achievement</span>
          <span *ngIf="date.errors['max']" class="text-danger">You cannot provide a date in the future</span>
        </ng-container>
      </div>
      <div class="form-group">
        <label for="type" class="required-field">Type</label>
        <select class="form-control" id="type" name="type" [(ngModel)]="achievement.type" required #type="ngModel">
          <option *ngFor="let t of types" [value]="t.name">{{ t.name }}</option>
        </select>
        <ng-container *ngIf="type.touched && type.errors">
          <span *ngIf="type.errors['required']" class="text-danger">You must provide a type for the achievement</span>
        </ng-container>
      </div>
      <div class="form-group">
        <label for="evidence" class="required-field">Evidence</label>
        <textarea #evidence="ngModel" class="form-control" minlength="10" maxlength="2500" id="evidence" name="evidence"
                  [(ngModel)]="achievement.evidence" rows="5" cols="20"></textarea>
        <div class="d-flex">
          <span class="ms-auto me-3 text-secondary">{{ achievement.evidence?.length || 0 }} / 2500</span>
        </div>
        <ng-container *ngIf="evidence.touched && evidence.errors">
          <span *ngIf="evidence.errors['required']"
                class="text-danger">You must provide evidence for the achievement</span>
          <span *ngIf="evidence.errors['minlength']" class="text-danger">Evidence must be at least 10 characters</span>
          <span *ngIf="evidence.errors['maxlength']"
                class="text-danger">Evidence must be less than 2500 characters</span>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <div class="form-check me-auto" *ngIf="!achievement.id">
      <input type="checkbox" class="form-check-input" id="add_more" [(ngModel)]="keepModalOpen">
      <label class="form-check-label" for="add_more">Add another achievement</label>
    </div>
    <button class="btn btn-success" type="button" (click)="save(achievement, addAchievementForm)"
            [disabled]="addAchievementForm.untouched || addAchievementForm.invalid">
      <span class="fa fa-save" aria-hidden="true">&nbsp;</span> Save
    </button>
    <button class="btn btn-warning" aria-label="Cancel" (click)="modal.dismiss('cancel')">
      Cancel
    </button>
  </div>

</ng-template>
